var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-box" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            size: "mini",
            "max-height": "350px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "transactionType",
              label: "交易类型",
              align: "center",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "merchantOrderNo",
              label: "商户单号",
              align: "center",
              width: "220",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "transactionOrderNo",
              label: "交易单号",
              align: "center",
              width: "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "transactionDetail",
              label: "交易明细",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.transactionDetail.split(" "),
                    function (item, i) {
                      return _c("div", { key: i }, [
                        _c("div", [_vm._v(_vm._s(item))]),
                      ])
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "amount", label: "金额", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operatingEnter",
              label: "操作入口",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "transactionTime", label: "时间", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "操作", align: "center" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return !_vm.info.tc
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.getDetail(
                                    scope.row.transactionOrderNo,
                                    scope.row.transactionType
                                  )
                                },
                              },
                            },
                            [_vm._v("\n          查询\n        ")]
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "“true”",
            title: _vm.transactionDetail.title,
            center: "",
            visible: _vm.dialogVisible,
            width: "25%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "交易状态：" + _vm._s(_vm.transactionDetail.transactionStatus)
            ),
          ]),
          _vm.transactionDetail.errorMsg
            ? _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n      失败原因：" +
                    _vm._s(_vm.transactionDetail.errorMsg) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "title" }, [
            _vm._v("借贷标识：" + _vm._s(_vm.transactionDetail.borrowingFlag)),
          ]),
          _c("div", { staticClass: "title" }, [
            _vm._v("交易完成时间：" + _vm._s(_vm.transactionDetail.finishTime)),
          ]),
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "交易金额：" + _vm._s(_vm.transactionDetail.transactionAmount)
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("返 回")]
              ),
              _vm.isButtonAvailable
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleThirdRefund },
                    },
                    [_vm._v("\n        三方退款\n      ")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("我知道了")]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }